export default __webpack_public_path__ + "static/aqua-1-265cac54d6fa2c4685d7d40a9805fc46.jpg";